import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/nink/page.tsx");
